module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Franklin W. Dixon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Franklin W. Dixon is the pen name used by a variety of different authors (Charles Leslie McFarlane, a Canadian author, being the first) who wrote The Hardy Boys novels. ")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ALGzup/tc-custom/9781416982890.jpg?1730494026794",
      "alt": "This image is the cover for the book Haunted, Hardy Boys Super Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunted, Hardy Boys Super Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("ATAC Briefing for Agents Frank and Joe Hardy:")]), _c('br'), _c('i', [_vm._v("Special Paranormal Operation")]), _c('br'), _c('br'), _c('b', [_vm._v("MISSION")]), _vm._v(": Investigate possible supernatural disturbances at the Undercliff House of Detention, formerly an insane asylum in the 1800s. "), _c('br'), _c('br'), _c('b', [_vm._v("LOCATION")]), _vm._v(": Juvenile detention center in Glastonbury, CT. "), _c('br'), _c('br'), _c('b', [_vm._v("POTENTIAL VICTIMS")]), _vm._v(": Many of the inmates appear to be dying from pure terror! "), _c('br'), _c('br'), _c('b', [_vm._v("SUSPECTS")]), _vm._v(": Lara Renner claims to be a psychic with a direct line to the spirit behind the hauntings, but perhaps her motives are more down-to-earth. Then there's the cafeteria worker with a major grudge. Or could it be the culprits are truly ghosts?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0